module.exports = __webpack_public_path__ + "static/21-ee18bf3e7d90f359f658f79152296e23.mp4";